<div #gameContainer class="game-container"></div>

<!--
<div #gameContainer class="game-container workInProgress"> 
  <div>
    {{'Work in progress.. Please come back later!'}}
  </div>
  <div>
    <button class="styledCloseBtn" (click)="cancel()">{{'Close Game Panel'}}</button>
  </div>
  
</div>
-->